import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    transition: all 0.3s ease;
    min-height: 100vh;
    padding-top: 0;
  }
  
  #root {
    padding-top: 0;
  }
  
  .main-content {
    margin-top: 80px;
    width: 100%;
    max-width: 1200px;
    padding: 0 1.5rem;
    margin-left: auto;
    margin-right: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    position: relative;
  }
  
  @media (max-width: 968px) {
    .main-content {
      margin-top: 72px;
      width: 100%;
      padding: 0 1rem;
    }
  }
  
  a {
    text-decoration: none;
    color: inherit;
    transition: all 0.3s ease;
  }
  
  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    outline: none;
    transition: all 0.3s ease;
  }
  
  .glass-effect {
    background: ${({ theme }) => theme.cardBg};
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .gradient-text {
    background: ${({ theme }) => theme.gradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }`;
